import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent {
  @Input() items: any[] = []; // Array of items to paginate
  @Input() itemsPerPage: number = 10; // Number of items per page
  @Output() pageItems = new EventEmitter<any[]>(); // Emit current page items

  public paginatedItems: any[] = []; // Current page items
  public currentPage: number = 1; // Track current page
  public totalPages: number = 1; // Total pages calculated

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnChanges(): void {
    // Update pagination whenever `items` or `itemsPerPage` changes
    this.updatePagination();
  }

  updatePagination(): void {
    if (!this.items || this.items.length === 0) {
      this.items = []; // Handle null or undefined items
    }
    this.totalPages = Math.ceil(this.items.length / this.itemsPerPage);
    this.updateCurrentPageItems();
  }

  updateCurrentPageItems(): void {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedItems = this.items.slice(startIndex, endIndex);

    // Emit the updated paginated items after ensuring change detection
    setTimeout(() => {
      this.pageItems.emit(this.paginatedItems);
    });
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updateCurrentPageItems();
    }
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updateCurrentPageItems();
    }
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updateCurrentPageItems();
    }
  }
}
